<template>
    <div>
        <div class="container">
            <header class="header">
                <div class="intro">
                    <div v-for="block in blocks">
                        <div v-html="block.content" v-if='block.order == 0'></div>
                    </div>
                </div>
                <div class="image">
                    <div class="arrow-image" :style="`transform: rotate(${arrowRotation}deg) translate(${arrowPositionY}%, 10%);`"></div>
                </div>
            </header>
        </div>
        <div class="careers">
            <main class="block-content container">
                <p v-if="lang === 'hu'"><strong>Nyított pozícióink</strong></p>
                <p v-if="lang === 'en'"><strong>Open positions at CÉH</strong></p>
                <p v-if="lang === 'de'"><strong>Unsere offene Stellen</strong></p>
                <article v-for="career in careersOrdered" class="career">
                    <h2 class="title">
                        <span style="font-weight: bold;">{{ career.title }}</span>
                        <span v-if="career.employment" class="employment">{{ career.employment }}</span>
                    </h2>
                    <p class="short-description">
                        {{ career.excerpt }}
                    </p>
                    <a class="btn view-more" :href="`/${lang}/karrier/${career.slug}`">
                        <span v-if="lang === 'hu'">tovább</span>
                        <span v-if="lang === 'en'">view</span>
                        <span v-if="lang === 'de'">weiter</span>
                    </a>
                </article>
            </main>
        </div>
        <div class="container">
            <div v-for="block in blocks">
                <div v-html="block.type == 'text' ? block.content : '<img src=\'/files/'+block.file_id+'/'+block.content+'\'/>'" v-if='block.order !== 0'></div>
            </div>
        </div>
        <div class="container">
            <section class="gallery">
                <div class="image-1" style="background-image: url('/img/career/vegeldaniel.com_131554.jpg');"></div>
                <div class="image-2" style="background-image: url('/img/career/Photo_11a_SZINHAZ_01.jpg');"></div>
                <div class="image-3" style="background-image: url('/img/career/Photo_6_Citadella_latvanyterv.jpg');"></div>
                <div class="image-4" style="background-image: url('/img/career/053_karacsony_2017_web.jpg');"></div>
                <div class="image-5" style="background-image: url('/img/career/_D856914.jpg');"></div>
                <div class="image-6" style="background-image: url('/img/career/Photo_24a.JPG');"></div>
            </section>
        </div>
    </div>
</template>

<script>
import Email from './Email.vue';
import { throttle } from 'lodash-es';
import axios from 'axios';
export default {
    components: {
        'email-tag': Email,
    },
    beforeMount() {
        axios.get('/pa/careers/').then(
            resp => {
                this.careers = resp.data.data;
            }
        );
        axios.get(`/pa/career-blocks/?lang=${this.lang}`).then(
            resp => {
                this.blocks = resp.data;
            }
        );
        window.addEventListener('scroll', throttle(this.scroll));

        axios.get('/cookies/functionalCookieIsActive').then(resp => {
            if (resp.data == 1) {
                this.functionalCookieIsActive = true;
            } else {
                this.functionalCookieIsActive = false;
            }
        });
    },
    computed: {
        lang() {
            return this.$route.params.lang;
        },
        careersOrdered() {
            return [...this.careers].sort((a, b) => a.order - b.order);
        },
    },
    methods: {
        scroll() {
            if (window.pageYOffset < 601) {
                var degree = (window.pageYOffset / 600) * 30;
                var posY = (window.pageYOffset / 600) * 100;
                this.arrowRotation = -60 - degree;
                this.arrowPositionY = 33.5 + posY;
            }
        },
    },
    data() {
        return {
            careers: [],
            blocks: [],
            arrowRotation: -60,
            arrowPositionY: 33.5,
        };
    },
};
</script>

<style lang="scss" scoped>
@import './../../sass/variables';

.gallery {
    grid-template-areas:
        'a1 a1 a1 a2 a2 a4 a4 a4 a5 a5 a5'
        'a1 a1 a1 a2 a2 a4 a4 a4 a5 a5 a5'
        'a1 a1 a1 a2 a2 a4 a4 a4 a6 a6 a6'
        'a1 a1 a1 a3 a3 a4 a4 a4 a6 a6 a6'
        'a1 a1 a1 a3 a3 a4 a4 a4 a6 a6 a6';
    max-width: 1200px;
    margin: 50px auto;
    grid-gap: 20px;
    display: grid;
    height: 400px;
    width: 100%;

    @media screen and (max-width: $mobile-max) {
        display: block;
        .image-1, .image-2, .image-3, .image-4, .image-5, .image-6{
            width: 100%;
            height: 250px;
            margin-top: 15px;
        }
        height: 1550px;
    }

    div {
        background-position: center;
        background-size: cover;
    }

    .image-1 {
        grid-area: a1;
    }
    .image-2 {
        grid-area: a2;
    }
    .image-3 {
        grid-area: a3;
    }
    .image-4 {
        grid-area: a4;
    }
    .image-5 {
        grid-area: a5;
    }
    .image-6 {
        grid-area: a6;
    }
}

.header {
    padding-bottom: 120px;
    padding-top: 30px;
    display: flex;

    .intro {
        width: 60%;

        @media screen and (max-width: $mobile-max) {
            width: 100%;
        }
    }

    .image {
        position: relative;

        @media screen and (max-width: $mobile-max) {
            display: none;
        }

        .arrow-image {
            background-image: url('/img/career/technical-drawings.jpg');
            transform: rotate(-60deg) translate(33.5%, 10%);
            background-color: $light-blue;
            background-size: cover;
            position: absolute;
            height: 600px;
            width: 600px;
            left: 0;
            top: 0;

            &:after {
                background-color: #fff;
                position: absolute;
                display: block;
                height: 400px;
                bottom: -2px;
                width: 400px;
                content: '';
                right: -2px;
            }
        }
    }
}

.careers {
    background-image: url('/img/pattern-background.svg');
    background-color: lighten(#000, 97%);
    background-size: cover;
    padding-bottom: 120px;
    margin-bottom: 80px;
    padding-top: 120px;

    @media screen and (max-width: $mobile-max) {
        padding: 15px;
    }
}

.career {
    box-shadow: 0 5px 25px -10px rgba(0, 0, 0, 0.1);
    border: 1px solid lighten(#000, 97%);
    padding: 15px 180px 5px 20px;
    background-color: #fff;
    margin-bottom: 15px;
    border-radius: 4px;
    position: relative;

    @media screen and (max-width: $mobile-max) {
        padding: 25px;
    }

    &:hover {
        background-color: lighten(#000, 99%);
    }

    .title {
        text-transform: capitalize;
        margin-bottom: 10px;
		font-size: 18px;

        @media screen and (max-width: $mobile-max) {
            font-size: 15px;
        }
		
        a {
            text-decoration: none;
            font-weight: bold;
            font-size: 18px;
            color: $black;
        }

        .employment {
            color: lighten(#000, 60%);
            font-weight: 300;
            font-size: 12px;
            display: block;

            @media screen and (min-width: $mobile) {
                display: inline-block;
                font-size: 18px;

                &:before {
                    content: '/ ';
                }
            }
        }
    }

    .job-title {
        background-color: lighten(#000, 97%);
        text-transform: uppercase;
        vertical-align: bottom;
        display: inline-block;
        border-radius: 2px;
        margin-right: 10px;
        line-height: 18px;
        font-weight: bold;
        padding: 3px 8px;
        font-size: 11px;

        &:after {
            display: table;
            content: '';
        }

        @media screen and (min-width: $mobile) {
            display: inline-block;

            &:after {
                display: none;
            }
        }
    }

    .view-more {
        background-color: $light-blue;
        text-align: center;
        display: block;
        color: #fff;

        @media screen and (min-width: $mobile) {
            transform: translate(-140%, -50%);
            position: absolute;
            left: 100%;
            top: 50%;
        }
    }
}
</style>

<style>
.ql-align-center {
    display: block;
	margin-left: auto;
	margin-right: auto;
	text-align: center;
}
.ql-align-right {
    display: block;
    margin-left: auto;
    text-align: right;
}
</style>
